import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {InvoiceSummaryReportModel} from "./invoice-summary-report.model";

@Component({
    selector: "wbo-invoice-summary-report",
    templateUrl: "./invoice-summary-report.component.html",
    providers: [provideReportModel(InvoiceSummaryReportModel)]
})
export class InvoiceSummaryReportComponent extends AbstractReportPage {
    constructor(public model: InvoiceSummaryReportModel) {
        super();
    }
}
